import posthog from '@leyan/lytics';
import { useEffect } from 'react';

function useEntryTrack(page: string) {
  useEffect(() => {
    posthog.capture('$aide', {
      type: 'entry',
      page,
    });
  }, [page]);
}

export default useEntryTrack;
